<template>
  <router-view />
  <ModalProvider />
</template>

<script setup lang="ts">
import ModalProvider from './components/ModalProvider.vue'
</script>

